import type {
  ModalRutasNoDisponiblesProps,
  UseModalRutasNoDisponiblesReturn,
} from "./types";

export const useModalRutasNoDisponibles = ({
  setIsModalRutasNoDisponibles,
}: ModalRutasNoDisponiblesProps): UseModalRutasNoDisponiblesReturn => {
  const handleClose = () => {
    setIsModalRutasNoDisponibles(false);
  };

  return {
    handleClose,
  };
};
